"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TriggerTypeEnum = void 0;
var TriggerTypeEnum;
(function (TriggerTypeEnum) {
    TriggerTypeEnum["EVENT"] = "event";
})(TriggerTypeEnum = exports.TriggerTypeEnum || (exports.TriggerTypeEnum = {}));
